import React, { useState, useEffect } from "react";
import { fetchKonnektForms, PostKonnektForm } from "js/Api/index";
import { Button } from '../../../../Component/CommonFormEle';
import toast from "react-hot-toast";

const KonnektForms = ({ user }) => {

    const [allForms, setallForms] = useState([]);
    const [openCreaeBuildForm, setopenCreaeBuildForm] = useState(false);
    const [formType, setformType] = useState("");

    const GetKonnektForms = async () => {
        const result = await fetchKonnektForms(user.id, "all");
        if (result.success) {
            setallForms(result.data)
        } else {

        }
    };

    const CreateKonnektForm = async () => {
        var post_form = { form_type: formType, device_id: user.id, form_status: "draft", form_data: "" }
        const result = await PostKonnektForm(post_form);

        if (result.success) {
            await GetKonnektForms();
            toast.success(result.message);
        } else {
            toast.error(result.error);
        }
    };

    const UnSubmit = async () => {
        var post_form = { form_type: "telstra", device_id: user.id, form_status: "draft", form_data: allForms[0].formData }
        const result = await PostKonnektForm(post_form);

        if (result.success) {
            await GetKonnektForms();
            toast.success("Form status updated.");
        } else {
            toast.error(result.error);
        }
    };

    useEffect(() => {
        GetKonnektForms();
    }, [user.id]);

    function FormLink(isCopy) {
        const form_data = { id: user.id };
        const encodedData = btoa(JSON.stringify(form_data));
        var url = window.location.protocol + "//" + window.location.host + "/konnekt-form?data=" + encodedData;
        if (isCopy) {
            navigator.clipboard.writeText(url)
            toast.success('Copied');
        }
        else {
            var newTab = window.open(url, '_blank');
            if (newTab) {
                newTab.focus();
                try {
                    newTab.location.reload();
                } catch (e) {

                }
            } else {

            }
        }
    };

    return (
        <>
            <div>
                {allForms.length > 0 ?
                    <>
                        <div class="row mb-1">
                            <div class="col">
                                <strong>Status</strong>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                {allForms[0].status === "draft" && "Created"}
                                {allForms[0].status === "complete" && "Submitted"}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <button type="submit" class="btn cur-p btn-outline-dark" onClick={() => FormLink(true)}>Copy Link</button>&nbsp;&nbsp;
                                <button type="submit" class="btn cur-p btn-outline-dark" onClick={() => FormLink(false)}>View Build Form</button>&nbsp;&nbsp;
                                {allForms[0].status === "complete" &&
                                    <button type="submit" class="btn cur-p btn-outline-dark" onClick={() => UnSubmit()}>Unsubmit</button>
                                }
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div class="row mb-1">
                            <div class="col">
                                <strong>Status</strong>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                Not created
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <button type="submit" class="btn btn-dark" onClick={() => setopenCreaeBuildForm(true)}>Create Build Form</button>
                            </div>
                        </div>

                        {openCreaeBuildForm && (
                            <div className="modal" tabIndex={"-1"} role="dialog">
                                <div className="modal-dialog-scrollable" role="document">
                                    <div className="modal-content" style={{ width: "500px" }}>
                                        <div className="modal-header" style={{ padding: "0" }}>
                                            <h1 className="modal-title">Create Build Form</h1>
                                            <button className="close-button" onClick={() => setopenCreaeBuildForm(false)} >
                                                &times;
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div class="row mb-2">
                                                <div class="col">
                                                    Customer type
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col">
                                                    <select class="form-control" onChange={(e) => { setformType(e.target.value) }}>
                                                        <option value="">Select customer type</option>
                                                        <option value="telstra">Telstra</option>
                                                        <option value="non_telstra">Non-Telstra customer</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {formType === "non_telstra" &&
                                                <div class="row mb-2">
                                                    <div class="col">
                                                        The build form can only be used with Telstra customers at this point in time.
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="modal-footer">
                                            <Button onClick={() => setopenCreaeBuildForm(false)} class="btn cur-p btn-outline-dark">
                                                Close
                                            </Button>
                                            <Button onClick={() => CreateKonnektForm()} class="btn btn-dark" disabled={formType === "" || formType === "non_telstra"}>
                                                Create
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                }
            </div>

        </>
    )
}

export default KonnektForms;